module.exports = __webpack_public_path__ + "img/reward-slot.68d31bcf.png";